const host = process.env.REACT_APP_STATIC_ASSET_HOST;

export function getStaticUrlAsset(path: string): string {
  const newPath = path[0] !== '/' ? `/${path}` : path;

  return host + newPath;
}
